import React from 'react';
import templateIds from '../../../constants/templates.constants';
import useSitecoreContext from '../../../hooks/useSitecoreContext';
import Picture from '../../@shared/picture';
import RoutableSitecoreLink from '../../@shared/routableSitecoreLink';
import { useMenuDispatcher } from './menuContext';

const Logo = ({ fields }): JSX.Element => {
  const context = useSitecoreContext();

  const dispatch = useMenuDispatcher();
  const handleClick = (): void => {
    dispatch({ type: 'closeAll' });
  };

  const isHomePage = context?.sitecoreContext?.route?.templateId === templateIds.homeTemplateId;

  const LogoTag = isHomePage ? 'h1' : 'span';

  return (
    <LogoTag className="navigation__logo">
      <RoutableSitecoreLink className="navigation__logo__link" field={fields.logolink} onClick={handleClick}>
        <Picture
          editorialImageProps={{
            desktopImage: fields?.globalAssets?.logo,
            mobileImage: fields?.globalAssets?.mobileLogo,
            desktopTransformation: 'Size200',
            mobileTransformation: 'Size200',
            cssClassImageEl: 'navigation__logo__image',
          }}
        />
      </RoutableSitecoreLink>
    </LogoTag>
  );
};

export default Logo;
